/* eslint-disable react/no-array-index-key */
import React, { memo } from "react";
import useContactMessageData from "../../../hooks/inbox/data/useContactMessageData";
import ContactMC from "./ContactMC";

// RepliedContactMessageMC
const RepliedContactMessageMC = memo(({ message }) => {
  const { contacts } = useContactMessageData(message);
  return (
    <>
      {contacts.map((contact, index) => (
        <div
          key={`${message.id}-${index}`}
          className="tw-p-3 tw-mb-2 tw-cursor-pointer tw-text-sm tw-font-normal"
        >
          <ContactMC contact={contact} />
        </div>
      ))}
    </>
  );
});

RepliedContactMessageMC.displayName = "RepliedContactMessageMC";

export default RepliedContactMessageMC;
